import { Divider, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import moment from "moment";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import PhotoContainer from "../../Components/PhotoContainer/PhotoContainer";
import { useTranslation } from "react-i18next";

export default function Review(props) {
	const { handleNext, handleBack, renderControls } = props;
	const application = useSelector((state) => state.user.application);
	const email = useSelector((state) => state.auth.currentAuthenticatedUser?.email);
	const selfie = useSelector((state) => state.user.application.selfie);
	const id1 = useSelector((state) => state.user.application.id1);
	const id2 = useSelector((state) => state.user.application.id2);
	const { t } = useTranslation();
	useEffect(() => {
		console.log(application);
	}, [application]);
	return (
		<React.Fragment>
			<Typography variant="h6" color="secondary" fontWeight={"bold"} marginBottom={3}>
				{t("Review Information")}
			</Typography>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Full Name")}:
					</Typography>
					<Typography fontWeight={"bold"}>
						{application.personalInformation.firstName} {application.personalInformation.middleName} {application.personalInformation.lastName}
					</Typography>
				</Grid>
				{/* <Grid item xs={12} sm={6}>
          <Typography component="h6" fontWeight={"bold"} color="primary">
            Maiden Name:
          </Typography>
          <Typography fontWeight={"bold"}>
            {application.personalInformation.maidenName}
          </Typography>
        </Grid> */}
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Last at Birth Label")}:
					</Typography>
					<Typography fontWeight={"bold"}>{application.personalInformation.lastNameAtBirth || "-"}</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Gender")}
					</Typography>
					<Typography fontWeight={"bold"} textTransform="capitalize">
						{application.personalInformation.gender}
					</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Date of Birth")}:
					</Typography>
					<Typography fontWeight={"bold"}>{moment.utc(application.personalInformation.birthDate).format("MMM DD YYYY")}</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Email")}:
					</Typography>
					<Typography fontWeight={"bold"}>{email}</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Phone Number")}:
					</Typography>
					<Typography fontWeight={"bold"}>{application.personalInformation.phoneNumber}</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Place of Birth")}:
					</Typography>
					<Typography fontWeight={"bold"}>
						{application.personalInformation.birthCity}, {application.personalInformation.birthCountryCode}
					</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Criminal Offences")}:
					</Typography>
					<Typography fontWeight={"bold"}>{application.previousOffences ? "Yes" : "None"}</Typography>
				</Grid>
				<Grid item xs={12}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Addresses")}:
					</Typography>

					<ul style={{ listStyle: "none", paddingLeft: "10px", margin: "0" }}>
						{application.addressInformation?.map((a, index) => {
							return (
								<li key={index}>
									<Typography fontWeight={"bold"}>
										{a.streetLine1}, {a.streetLine2 ? `${a.streetLine2}, ` : ""} {a.city}, {a.province}, {a.postalCode}, {a.country} from{" "}
										{moment.utc(a.dateMoveIn).format("MMM DD YYYY")}
										{a.dateMoveOut ? `to ${moment.utc(a.dateMoveOut).format("MMM DD YYYY")}` : ""}
									</Typography>
								</li>
							);
						})}
					</ul>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Typography component="h6" fontWeight={"bold"} color="primary">
						{t("Selfie")}:
					</Typography>
					<Box style={{ position: "relative" }} sx={{ maxWidth: { sx: "100%", md: "60%" } }}>
						<div
							style={{
								background: "rgba(0,0,0,0.2)",
								border: " 2px solid black",
								position: "absolute",
								width: "175px",
								transform: "translate(-50%,-50%)",
								top: "50%",
								left: "50%",
								zIndex: 100,
								borderRadius: "50%",
								maxWidth: "100%",
								aspectRatio: "1/1",
							}}
						></div>
						<PhotoContainer src={selfie} />
					</Box>
				</Grid>
				<Grid item xs={12}>
					<Grid container>
						<Grid item xs={12} sm={6}>
							<Typography component="h6" fontWeight={"bold"} color="primary">
								{t("First ID Front")}:
							</Typography>
							<Box sx={{ maxWidth: { sx: "100%", md: "60%" } }}>
								<PhotoContainer src={id1.front} />
							</Box>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Typography component="h6" fontWeight={"bold"} color="primary">
								{t("First ID Back")}:
							</Typography>
							<Box sx={{ maxWidth: { sx: "100%", md: "60%" } }}>
								<PhotoContainer src={id1.back} />
							</Box>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={12}>
					<Grid container>
						<Grid item xs={12} sm={6}>
							<Typography component="h6" fontWeight={"bold"} color="primary">
								{t("Second ID Front")}:
							</Typography>
							<Box sx={{ maxWidth: { sx: "100%", md: "60%" } }}>
								<PhotoContainer src={id2.front} />
							</Box>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Typography component="h6" fontWeight={"bold"} color="primary">
								{t("Second ID Back")}:
							</Typography>
							<Box sx={{ maxWidth: { sx: "100%", md: "60%" } }}>
								<PhotoContainer src={id2.back} />
							</Box>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			{/* <div>
				<Typography component="h6" fontWeight={"bold"} color="primary">
					Full name:
				</Typography>
				<Typography fontWeight={"bold"}>
					{application.personalInformation.firstName} {application.personalInformation.middleNames} {application.personalInformation.lastName}
				</Typography>
			</div>
			<div>
				<Typography component="h6">Date of birth: </Typography>
				{application.personalInformation.dateOfBirth}
			</div>
			<div>
				<Typography component="h6">Email: </Typography>
				{email}
			</div>
			<div>
				<Typography component="h6">Telephone: </Typography>
				{application.personalInformation.phoneNumber}
			</div>
			<div>
				<Typography component="h6">Place of birth: </Typography>
				{application.personalInformation.birthCity}, {application.personalInformation.birthCountryCode}
			</div>
			<div>
				<Typography component="h6">Addresses: </Typography>
				<ul style={{ listStyle: "none", paddingLeft: "10px", margin: "0" }}>
					{application.addressInformation?.map((a, index) => {
						return (
							<li key={index}>
								{a.streetLine1}, {a.streetLine2}, {a.city}, {a.province},{a.postalCode},{a.country} from {a.dateMovedIn} to {a.dateMovedOut}
							</li>
						);
					})}
				</ul>
			</div>
			<div>
				<Typography component="h6">Criminal Offences: </Typography>

				{application.previousOffences ? "Yes" : "None"}
			</div> */}
			<Divider style={{ margin: "25px 0px" }} />
			<Typography>{t("Please review these details carefully.")}</Typography>
			{renderControls(handleNext, handleBack)}
		</React.Fragment>
	);
}
